/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { VehicleVoModel } from '@well/delivery-libs/vehicle-management/domain';

@Injectable({
  providedIn: 'root'
})
export class VehicleVoResourceService extends SelectableResourceService<VehicleVoModel> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      `${environmentService.getEnvironmentProperty('vehicleUrl')}/vos`,
      VehicleVoModel
    );
  }
}
